<div mat-dialog-actions fxLayoutAlign="center center" fxLayoutGap="10px" fxFlex>
    <button *ngFor="let button of nonDeleteButtons; let i = index" 
            mat-button
            mat-raised-button
            type="button"
            [color]="getButtonColor(button)" 
            (click)="buttonClick(button)">{{getButtonText(button)}}</button>
</div>